module.exports = __webpack_public_path__ + "static/Twidda-10fbbc1cda85bda3e4913a295ac529fe.gif";